import React from 'react';
import PropTypes from 'prop-types';
import {SocialShare} from '../shared/SocialShare';
import {isLoggedIn} from '../../utils/isLoggedIn';
import { NavLink } from 'react-router-dom';
import {styles} from './styles';
import {colors} from '../../shared/styles';
import { getResultsUrl } from '../../utils/resultsHelpers';

export const EventHeaderTabMenu = (
  {
    masterId,
    erpEventId,
    event,
    isMobile,
    tab,
    t
  }) => {

  const availableTypes = {
    about: '',
    startList: '/startList',
    results: '/results',
  };
  const typesToTranslations = {
    about: t('about'),
    startList: t('start list'),
    results: t('results')
  };
  const buttonsProps = {event, isMobile};

  return (
    <div className="container">
      <div className="row">
        {
          // Tabs
        }
        <div
          className="col-12 col-md-8"
          id='event-tab-menu'
          style={styles.tabsContainer(isMobile)}>
          {
            Object
              .keys(availableTypes)
              .filter((type) => isLoggedIn || type !== 'messages')
              .map((type, index) => (
                <NavLink
                  key={index}
                  id={`${type}-tab`}
                  exact to={type === 'results' ? getResultsUrl(masterId, erpEventId) : `/event/${masterId}${availableTypes[type]}`}
                  activestyle={styles.active}
                  className={'event-tab-menu'}
                  style={
                    tab === type ?
                      {...styles.tabItem, ...styles.active} :
                      {...styles.tabItem}
                  }>
                  {typesToTranslations[type]}
                </NavLink>
              ))
          }
        </div>
        {
          !isMobile &&
          <div className="col-md-4" style={styles.navRightSide}>
            <SocialShare
              style={styles.socialShare}
              buttonsProps={buttonsProps}
              followButton={false}
              isMobile={isMobile}
            />
          </div>
        }
      </div>
    </div>
  );
};

EventHeaderTabMenu.propTypes = {
  masterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  eventName: PropTypes.string,
  tab: PropTypes.string.isRequired,
  starters: PropTypes.object,
  event: PropTypes.object,
  t: PropTypes.func
};

EventHeaderTabMenu.defaultProps = {
  curatedMode: false,
  starters: {},
  color: colors.white,
  masterId: 0,
};



/** WEBPACK FOOTER **
 ** ./components/heroImage/EventHeaderTabMenu.js
 **/